import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { ReceptorRecord } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import {
  DOCUMENT_TYPE,
  GetEvidenceIndexPageRequest,
  EvidenceWrapperResponse,
  GetEvidenceGroupByIdRequest,
  GetEvidenceGroupByIdResponse,
  GetLatestEvidenceGroupsRequest,
  GetLatestEvidenceGroupsResponse,
  GetLatestEvidenceRequest,
  ListEvidenceGroupsRequest,
  ListEvidenceGroupsResponse,
  ListEvidenceRequest,
  GetEvidenceInstanceListRequest,
  GetControlEvidenceTabRequest,
  GetRequestEvidenceTabRequest,
  LinkControlsToEvidenceRequest,
  LinkRequestsToEvidenceRequest,
  GetEvidenceControlsRequest,
  GetEvidenceControlsResponse,
  EVIDENCE_READ_ONLY_FIELDS,
  UpdateEvidenceReadOnlyFieldsRequest,
  EvidenceReadOnlyFields,
  EvidenceReadOnlyField,
  EvidenceWrapper,
  Evidence,
  GetEvidenceGroupIfExistsResponse,
  GetEvidenceGroupIfExistsRequest,
  LinkEvidenceToControlRequest,
  AddEvidenceLabelRequest,
  RemoveEvidenceLabelRequest,
  EvidenceGroup,
} from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import {
  EvidenceFilter as EvidenceServiceEvidenceFilter,
  GetRelevantDateFilterRequest,
  GetRelevantDateFilterResponse,
  ListEvidenceBeingIndexedRequest,
  UpdateCaptionRequest,
} from '@trustero/trustero-api-web/lib/evidence/service_pb'
import { EvidenceServicePromiseClient } from '@trustero/trustero-api-web/lib/evidence/service_grpc_web_pb'
import { AttachmentPromiseClient } from '@trustero/trustero-api-web/lib/attachment/attachment_grpc_web_pb'
import { useLocation, useParams } from 'react-router-dom'
import { useImportedRecordModal } from 'src/components/ModalForms/useImportedRecordModal'
import {
  GRC_PLATFORM,
  ReadOnlyFieldDetail,
} from '@trustero/trustero-api-web/lib/common/grc_platform_pb'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import queryString, { ParsedQuery } from 'query-string'
import { FilterParam } from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.types'
import { BoolValue } from 'google-protobuf/google/protobuf/wrappers_pb'
import {
  ListDirectoryScanSettingsRequest,
  ListDirectoryScanSettingsResponse,
  DeleteDirectoryScanSettingRequest,
  GetDirectoryScanSettingRequest,
  GetDirectoryScanSettingResponse,
  UpdateDirectoryScanSettingLabelsRequest,
  UpdateDirectoryScanSettingRequest,
  UpdateDirectoryScanSettingResponse,
} from '@trustero/trustero-api-web/lib/receptorutil/receptorutil_pb'
import { ReceptorUtilPromiseClient } from '@trustero/trustero-api-web/lib/receptorutil/receptorutil_grpc_web_pb'
import { GrpcResponse, NewGrpcResponse } from 'src/components/async/hooks/types'
import {
  AuditRecords,
  EvidenceFilter,
  GetAuditsRequest,
} from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { useSwrImmutableGrpc } from 'src/components/async/useSwrImmutableGrpc'
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb'
import { useGrpcRevalidateByMethod } from 'src/components'
import { AuditPromiseClient } from '@trustero/trustero-api-web/lib/audit/audit_grpc_web_pb'
import { EvidenceManagementPromiseClient } from '@trustero/trustero-api-web/lib/evidencemgmt/evidencemgmt_grpc_web_pb'
import { useAuthorizedGrpcClient } from 'src/adapter/grpcClient'
import { ReceptorPromiseClient } from '@trustero/trustero-api-web/lib/agent/receptor_grpc_web_pb'
import { useInvalidateReceptorsCache } from 'src/components/async/model/receptor/useReceptors'
import { useInvalidateControlTestStaleness } from 'src/components/async/model/control/useControlTestStaleness'
import { useInProgressReceptorScans } from 'src/pages/Receptors/receptors.hooks'
import { useInvalidateEvidence } from 'src/Utils/swrCacheInvalidation'
import { useFetchDocumentBodyAllowMultipart } from 'src/components/async/document/useDocument'
import { getErrorMessage, isParsedPartArray } from 'src/Utils/globalHelpers'
import { isEvidenceFile } from 'src/components/ModalForms/Evidence/evidenceUtils'
import { documentBodyAsFile } from 'src/adapter/AttachmentAdapter'
import { useInAudit } from 'src/context/AuditContext'
import { labelNamesForSearch, useLabelMap } from 'src/context/labelMap'
import cloneDeep from 'lodash/cloneDeep'
import { useNewModel } from 'src/components/async/hooks/useNewModel'
import { SearchableData } from 'src/Utils/search/search.types'
import { prepareSearchableData } from 'src/Utils/search/search.helpers'
import { cellDisplayText } from 'src/components/Reusable/Evidence/evidence.details'
import { getEvidenceSourceLabel } from 'src/Utils/Evidence/evidence.helpers'
import { formatEvidenceCaption } from 'src/Utils/helpers/string.helpers'
import { formatISODateTime } from 'src/Utils/formatDate'
import {
  ControlFilter,
  ControlToEvidenceMappingInfo,
  EvidenceFilter as EvidenceManagementEvidenceFilter,
  EvidenceToControlMappingInfo,
  GetControlToEvidenceMappingInfoRequest,
  GetControlToEvidenceMappingInfoResponse,
  GetControlToEvidenceMappingsRequest,
  GetControlToEvidenceMappingsResponse,
  GetEvidenceToControlMappingInfoRequest,
  GetEvidenceToControlMappingInfoResponse,
  GetEvidenceToControlMappingsRequest,
  GetEvidenceToControlMappingsResponse,
} from '@trustero/trustero-api-web/lib/evidencemgmt/evidencemgmt_pb'
import { GridValidRowModel } from '@mui/x-data-grid'
import { ConfirmationContext } from 'src/Confirmation'
import { RpcError } from 'grpc-web'
import log from 'loglevel'
import isFunction from 'lodash/isFunction'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { useConfirmationModal } from 'src/components/ModalForms'
import {
  applyEvidenceFilters,
  applyEvidenceGroupFilters,
  applyEvidenceGroupSort,
  applyEvidenceIndexPageFilters,
  applyEvidenceIndexPageSort,
  getEvidenceLink,
  getSourcesMarkdown,
  isShowingAllDates,
  parseSourceQueryParams,
} from './evidence.helpers'
import {
  EVIDENCE_INDEX_CONFIG,
  EvidenceConfigType,
  EvidenceIndexConfigType,
  EvidenceIndexHeader,
  EvidenceIndexType,
} from './evidence.constants'

export const useInvalidateEvidenceGroups = (): (() => Promise<void>) => {
  const mutateFunc = useGrpcRevalidateByMethod()

  return useCallback(async () => {
    await Promise.all([
      mutateFunc(AttachmentPromiseClient.prototype.getLatestEvidenceGroups),
      mutateFunc(AttachmentPromiseClient.prototype.listEvidenceGroups),
      mutateFunc(AttachmentPromiseClient.prototype.getEvidenceGroupById),
      mutateFunc(AttachmentPromiseClient.prototype.getEvidenceIndexPageView),
    ])
  }, [mutateFunc])
}

export const useLatestEvidenceRequest = (): GetLatestEvidenceRequest => {
  const location = useLocation()

  return useMemo(() => {
    const req = new GetLatestEvidenceRequest()
    const queryParams: ParsedQuery<string> = queryString.parse(
      location.search,
      {
        arrayFormat: 'bracket',
      },
    )
    // Apply all filters for each parameter in URL
    Object.values(FilterParam).forEach((filterType: FilterParam) =>
      applyEvidenceFilters(req, queryParams, filterType),
    )
    return req
  }, [location.search])
}

export const useEvidenceRequest = (): ListEvidenceRequest => {
  const location = useLocation()

  return useMemo(() => {
    const req = new ListEvidenceRequest()
    const queryParams: ParsedQuery<string> = queryString.parse(
      location.search,
      {
        arrayFormat: 'bracket',
      },
    )
    // Apply all filters for each parameter in URL
    Object.values(FilterParam).forEach((filterType: FilterParam) =>
      applyEvidenceFilters(req, queryParams, filterType),
    )
    return req
  }, [location.search])
}

export const useEvidenceAudits = ({
  caption,
  contentId,
  discoveryId,
  relevantDate,
}: {
  caption: string
  contentId: string
  discoveryId: string
  relevantDate: Timestamp
}): GrpcResponse<AuditRecords> => {
  const req = useMemo(() => {
    const evidenceFilter = new EvidenceFilter()
      .setCaption(caption)
      .setContentId(contentId)
      .setDiscoveryId(discoveryId)
      .setRelevantDate(relevantDate)
    const req = new GetAuditsRequest()
    req
      .setEvidenceFilter(evidenceFilter)
      .setIsClosed(new BoolValue().setValue(false))
    return req
  }, [caption, contentId, discoveryId, relevantDate])

  const { response } = useSwrImmutableGrpc(
    AuditPromiseClient.prototype.getAudits,
    req,
    true,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceGroupsRequest = (): ListEvidenceGroupsRequest => {
  const location = useLocation()

  const queryParams: ParsedQuery<string> = queryString.parse(location.search, {
    arrayFormat: 'bracket',
  })
  const req = useEvidenceGroupsRequestFromParsedQuery(queryParams)
  return req
}

export const useEvidenceGroupsRequestFromParsedQuery = (
  queryParams: ParsedQuery<string>,
): ListEvidenceGroupsRequest => {
  const newModel = useNewModel(queryParams)
  return useMemo(() => {
    const req = new ListEvidenceGroupsRequest()
    // Default to new model, allow us to swtich to old model if needed for testing
    req.setUseNewModel(newModel)
    Object.values(FilterParam).forEach((filterType: FilterParam) =>
      applyEvidenceGroupFilters(req, queryParams, filterType),
    )
    applyEvidenceGroupSort(req, queryParams)
    return req
  }, [queryParams, newModel])
}

export const useLatestEvidenceGroupsRequestFromParsedQuery = (
  queryParams: ParsedQuery<string>,
  // Set by callers offering evidence to link. See GetLatestEvidenceGroupsRequest's
  // audit_scopes_dates_only: in an audit the list is otherwise narrowed to evidence the
  // audit's controls already reach, which is the one thing a picker must not do.
  { auditScopesDatesOnly = false }: { auditScopesDatesOnly?: boolean } = {},
): GetLatestEvidenceGroupsRequest => {
  const newModel = useNewModel(queryParams)
  return useMemo(() => {
    const req = new GetLatestEvidenceGroupsRequest()
    // Default to new model, allow us to swtich to old model if needed for testing
    req.setUseNewModel(newModel)
    req.setUseSnappyCode(queryParams.slow == null)
    req.setShowSnappyStats(queryParams.stats != null)
    req.setIncludeOutOfWindow(isShowingAllDates(queryParams))
    req.setAuditScopesDatesOnly(auditScopesDatesOnly)
    Object.values(FilterParam).forEach((filterType: FilterParam) =>
      applyEvidenceGroupFilters(req, queryParams, filterType),
    )
    applyEvidenceGroupSort(req, queryParams)
    return req
  }, [queryParams, newModel, auditScopesDatesOnly])
}

// The evidence show page's request. Built from the params of the list it was reached from,
// not from its own URL: those carry only sourceRoute/sourceParams, so filters — Show All
// among them — are invisible to a plain location.search read. Prev/next walks that list, so
// it has to be scoped the same way.
export const useLatestEvidenceGroupsRequestFromSource =
  (): GetLatestEvidenceGroupsRequest => {
    const location = useLocation()
    const queryParams = useMemo(
      () => parseSourceQueryParams(location.search),
      [location.search],
    )
    return useLatestEvidenceGroupsRequestFromParsedQuery(queryParams)
  }

export const useLatestEvidenceGroupsRequest =
  (): GetLatestEvidenceGroupsRequest => {
    const location = useLocation()
    const queryParams: ParsedQuery<string> = useMemo(
      () => queryString.parse(location.search, { arrayFormat: 'bracket' }),
      [location.search],
    )
    const req = useLatestEvidenceGroupsRequestFromParsedQuery(queryParams)

    return req
  }

export const useLatestEvidenceGroups = (
  req: GetLatestEvidenceGroupsRequest = new GetLatestEvidenceGroupsRequest(),
  shouldFetch = true,
): GrpcResponse<GetLatestEvidenceGroupsResponse> => {
  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getLatestEvidenceGroups,
    req,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceGroups = (
  req: ListEvidenceGroupsRequest = new ListEvidenceGroupsRequest(),
  shouldFetch = true,
): GrpcResponse<ListEvidenceGroupsResponse> => {
  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.listEvidenceGroups,
    req,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useUpdateCaption = (): ((
  evidenceId: string,
  caption: string,
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(EvidenceServicePromiseClient)
  return useCallback(
    async (evidenceId: string, caption: string) => {
      const request = new UpdateCaptionRequest()
        .setEvidenceId(evidenceId)
        .setCaption(caption)
      await client.updateCaption(request)
    },
    [client],
  )
}

export const useEvidenceSources = (
  contentId: string,
  mime: string,
  isAutomated: boolean,
): (() => Promise<string | null>) => {
  const fetchDocumentBody = useFetchDocumentBodyAllowMultipart(contentId, mime)
  return useCallback(async () => {
    const docBody = await fetchDocumentBody()
    if (docBody) {
      if (isParsedPartArray(docBody)) {
        const sourcesPart = docBody.find(
          (part) =>
            part.headers
              .get('content-disposition')
              ?.includes('receptor_v1.Sources') ||
            (part.headers.get('content-disposition')?.includes('protobuf') &&
              part.headers.get('name')?.includes('receptor_v1.Sources')),
        )
        if (!sourcesPart) return null
        const sourcesBytes = sourcesPart.body as Uint8Array
        const sourcesMarkdown = getSourcesMarkdown(sourcesBytes, true)
        return sourcesMarkdown
      }
      const sources =
        isAutomated && docBody instanceof Uint8Array
          ? getSourcesMarkdown(docBody, false)
          : ''
      return sources
    }
    return null
  }, [isAutomated, fetchDocumentBody])
}

export const useEvidenceConfigs = (
  contentId: string,
  mime: string,
  isAutomated: boolean,
  caption: string,
): (() => Promise<EvidenceConfigType[] | null>) => {
  const fetchDocumentBody = useFetchDocumentBodyAllowMultipart(contentId, mime)
  return useCallback(async () => {
    const docBody = await fetchDocumentBody()
    if (docBody) {
      if (isParsedPartArray(docBody)) {
        const bodyParts = docBody.filter((part) =>
          part.headers.get('content-disposition')?.includes('file'),
        )
        if (!bodyParts.length) return null
        const configs = bodyParts.map((bodyPart) => {
          const body = bodyPart.body
          const mimeType = bodyPart.headers.get('content-type') || ''
          const name =
            bodyPart.headers
              .get('content-disposition')
              ?.split('filename=')[1]
              ?.replace(/['"]/g, '') || ''
          const isMultipartAutomated = mimeType === 'application/protobuf'
          const file = isEvidenceFile(mimeType)
            ? documentBodyAsFile(body, caption, mimeType)
            : null
          return {
            body,
            mimeType,
            isAutomated: isMultipartAutomated,
            file,
            name,
          } as EvidenceConfigType
        })
        return configs
      }
      const file = isEvidenceFile(mime)
        ? documentBodyAsFile(docBody, caption, mime)
        : null
      return [
        {
          body: docBody,
          mimeType: mime,
          isAutomated,
          file,
          name: caption,
        } as EvidenceConfigType,
      ]
    }
    return null
  }, [mime, isAutomated, fetchDocumentBody, caption])
}

export const useEvidenceLinkNoFetch = (
  evidenceInstanceId: string,
  controlId?: string,
  requestId?: string,
): string => {
  const location = useLocation()
  const { pageContext } = useParams()

  const evidenceLink = useMemo(
    () =>
      getEvidenceLink(
        evidenceInstanceId,
        location.search,
        pageContext,
        controlId,
        requestId,
      ),
    [location.search, pageContext, controlId, evidenceInstanceId, requestId],
  )

  return evidenceLink
}

export const useEvidencePermalinkForGrid = (
  evidenceInstanceId: string,
): string => {
  const { pageContext } = useParams()

  const evidenceLink = useMemo(
    () => getEvidenceLink(evidenceInstanceId, '', pageContext),
    [evidenceInstanceId, pageContext],
  )

  return evidenceLink
}

export const useEvidenceIndexHeaders = (
  isReadonly = false,
): EvidenceIndexConfigType => {
  const { auditId } = useInAudit()
  let config = null
  if (isReadonly) {
    config = cloneDeep(EVIDENCE_INDEX_CONFIG[EvidenceIndexType.READONLY])
  } else {
    config = cloneDeep(EVIDENCE_INDEX_CONFIG[EvidenceIndexType.DMS])
  }
  if (!auditId) {
    config[EvidenceIndexHeader.LINKED_REQUESTS] = false
  }
  const showLabels = IsGatekeeperEnabled(GatekeeperFlag.LABELS)
  if (!showLabels) {
    config[EvidenceIndexHeader.LABELS] = false
  }
  return config
}

export const useEvidenceIndexGridTemplateColumns = (
  hasSharepoint: boolean,
  showLabels?: boolean,
): string => {
  const { auditId } = useInAudit()
  const isLabelsEnabled =
    showLabels ?? IsGatekeeperEnabled(GatekeeperFlag.LABELS)
  const labelsTrack = isLabelsEnabled ? 'auto ' : ''

  if (auditId) {
    return hasSharepoint
      ? `max-content 1fr ${labelsTrack}repeat(4, max-content) repeat(2, 12em) max-content repeat(3, min-content)`
      : `max-content 1fr ${labelsTrack}10em max-content repeat(2, max-content) repeat(3, min-content)`
  }
  return hasSharepoint
    ? `max-content 1fr ${labelsTrack}repeat(3, max-content) repeat(2, 12em) max-content repeat(3, min-content)`
    : `max-content 1fr ${labelsTrack}10em max-content repeat(2, max-content) repeat(3, min-content)`
}

export const useEvidenceGroupById = (
  evidenceGroupId: string,
  shouldFetch = true,
): GrpcResponse<GetEvidenceGroupByIdResponse> => {
  // The audit scopes window_status: inside one, the audit's period decides whether this
  // evidence counts, not the account's own earliest evidence date.
  const { auditId } = useInAudit()
  const request = new GetEvidenceGroupByIdRequest()
    .setId(evidenceGroupId)
    .setAuditId(auditId || '')

  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getEvidenceGroupById,
    request,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceGroupIfExists = (
  evidenceGroupId: string,
  shouldFetch = true,
): GrpcResponse<GetEvidenceGroupIfExistsResponse> => {
  const request = new GetEvidenceGroupIfExistsRequest().setId(evidenceGroupId)

  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getEvidenceGroupIfExists,
    request,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useGetEvidenceIndexPageFromParsedQuery = (
  queryParams: ParsedQuery<string>,
): GetEvidenceIndexPageRequest => {
  const { auditId } = useInAudit()

  return useMemo(() => {
    const req = new GetEvidenceIndexPageRequest()
      .setAuditId(auditId || '')
      .setShowStats(queryParams.stats != null)
      .setIncludeOutOfWindow(isShowingAllDates(queryParams))
    Object.values(FilterParam).forEach((filterType: FilterParam) =>
      applyEvidenceIndexPageFilters(req, queryParams, filterType),
    )
    applyEvidenceIndexPageSort(req, queryParams)
    return req
  }, [queryParams, auditId])
}

// useIsShowingAllDates reads the Show All toggle out of the URL. Shared by the evidence
// lists and the controls index count, so the count cannot claim evidence the list hides.
export const useIsShowingAllDates = (): boolean => {
  const location = useLocation()
  return useMemo(
    () =>
      isShowingAllDates(
        queryString.parse(location.search, { arrayFormat: 'bracket' }),
      ),
    [location.search],
  )
}

export const useGetEvidenceIndexPageRequest =
  (): GetEvidenceIndexPageRequest => {
    const location = useLocation()
    const queryParams: ParsedQuery<string> = useMemo(
      () => queryString.parse(location.search, { arrayFormat: 'bracket' }),
      [location.search],
    )
    const req = useGetEvidenceIndexPageFromParsedQuery(queryParams)

    return req
  }

export const useEvidenceIndexPage = (
  req: GetEvidenceIndexPageRequest = new GetEvidenceIndexPageRequest(),
  shouldFetch = true,
): GrpcResponse<EvidenceWrapperResponse> => {
  const { auditId } = useInAudit()
  req.setAuditId(auditId || '')

  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getEvidenceIndexPageView,
    req,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useControlEvidenceTabRequest = (
  req: GetControlEvidenceTabRequest = new GetControlEvidenceTabRequest(),
  shouldFetch = true,
): GrpcResponse<EvidenceWrapperResponse> => {
  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getControlEvidenceTabView,
    req,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useRequestEvidenceTabRequest = (
  req: GetRequestEvidenceTabRequest = new GetRequestEvidenceTabRequest(),
  shouldFetch = true,
): GrpcResponse<EvidenceWrapperResponse> => {
  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getRequestEvidenceTabView,
    req,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceInstanceList = (
  evidenceId: string,
  controlId?: string,
  shouldFetch = true,
): GrpcResponse<EvidenceWrapperResponse> => {
  const { auditId } = useInAudit()
  const location = useLocation()

  const queryParams: ParsedQuery<string> = queryString.parse(location.search, {
    arrayFormat: 'bracket',
  })

  const req = new GetEvidenceInstanceListRequest()
    .setShowStats(queryParams.stats != null)
    .setEvidenceId(evidenceId)
    .setAuditId(auditId || '')
    .setIncludeOutOfWindow(isShowingAllDates(queryParams))
  controlId && req.setControlId(controlId)

  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getEvidenceInstanceList,
    req,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useGetRelevantDateFilter = (
  evidenceInstanceId: string,
): GrpcResponse<GetRelevantDateFilterResponse> => {
  const request = new GetRelevantDateFilterRequest().setEvidenceInstanceId(
    evidenceInstanceId,
  )

  const { response } = useSwrImmutableGrpc(
    EvidenceServicePromiseClient.prototype.getRelevantDateFilter,
    request,
    !!evidenceInstanceId,
  )
  return NewGrpcResponse(response)
}

export const useLinkControlsToEvidence = (): ((
  evidenceId: string,
  controlIds: string[],
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(AttachmentPromiseClient)

  return useCallback(
    async (evidenceId: string, controlIds: string[]) => {
      const request = new LinkControlsToEvidenceRequest()
        .setEvidenceId(evidenceId)
        .setControlIdsList(controlIds)
      await client.linkControlsToEvidence(request)
    },
    [client],
  )
}

export const useLinkRequestsToEvidence = (): ((
  evidenceId: string,
  requestIds: string[],
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(AttachmentPromiseClient)

  return useCallback(
    async (evidenceId: string, requestIds: string[]) => {
      const request = new LinkRequestsToEvidenceRequest()
        .setEvidenceId(evidenceId)
        .setRequestIdsList(requestIds)
      await client.linkRequestsToEvidence(request)
    },
    [client],
  )
}

export const useLinkEvidenceToControl = (): ((
  controlId: string,
  evidenceIds: string[],
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(AttachmentPromiseClient)
  const invalidateStaleness = useInvalidateControlTestStaleness()

  return useCallback(
    async (controlId: string, evidenceIds: string[]) => {
      const request = new LinkEvidenceToControlRequest()
        .setControlId(controlId)
        .setEvidenceIdsList(evidenceIds)
      try {
        await client.linkEvidenceToControl(request)
      } finally {
        // Linked evidence feeds the evidence hash, so the control's latest test can
        // become outdated the moment this lands.
        await invalidateStaleness()
      }
    },
    [client, invalidateStaleness],
  )
}

export const useGetEvidenceControls = (
  evidenceId: string,
): GrpcResponse<GetEvidenceControlsResponse> => {
  const { auditId } = useInAudit()
  const request = new GetEvidenceControlsRequest().setEvidenceId(evidenceId)
  auditId && request.setAuditId(auditId)
  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.getEvidenceControls,
    request,
    true,
  )
  return NewGrpcResponse(response)
}

export const useDismissEvidenceReadOnlyWarning = (
  evidenceId: string,
  fields: EVIDENCE_READ_ONLY_FIELDS[],
): (() => Promise<void>) => {
  const evidenceClient = useAuthorizedGrpcClient(AttachmentPromiseClient)

  return async () => {
    const request = new UpdateEvidenceReadOnlyFieldsRequest()
      .setEvidenceId(evidenceId)
      .setUpdates(
        new EvidenceReadOnlyFields().setFieldsList([
          ...fields.map((field) =>
            new EvidenceReadOnlyField()
              .setField(field) //
              .setDetails(
                new ReadOnlyFieldDetail().setIsWarningDismissed(
                  new BoolValue().setValue(true),
                ),
              ),
          ),
        ]),
      )
    await evidenceClient.updateEvidenceReadOnlyFields(request)
  }
}

export const useImportedEvidenceModalOnClick = ({
  grcPlatform,
  showModal,
  evidenceId,
  fields,
}: {
  grcPlatform?: GRC_PLATFORM
  showModal?: boolean
  evidenceId: string
  fields: EVIDENCE_READ_ONLY_FIELDS[]
}): ((onClick: () => void) => Promise<void>) => {
  const dismissWarningFunction = useDismissEvidenceReadOnlyWarning(
    evidenceId,
    fields,
  )

  const importedRecordModal = useImportedRecordModal({
    modelType: MODEL_TYPE.EVIDENCE,
    grcPlatform,
    onUpdate: async (onClick: () => void) => {
      await onClick()
    },
    showModal,
    dismissWarningFunction,
  })

  return async (onClick: () => void) => {
    await importedRecordModal(onClick)
  }
}

export const useSearchableEvidence = (
  evidence: EvidenceWrapper[],
): SearchableData<EvidenceWrapper>[] => {
  const labelMap = useLabelMap()
  const searchableEvidence = useMemo(() => {
    return prepareSearchableData(
      evidence,
      (evidence: EvidenceWrapper) => evidence.getId(),
      (evidence: EvidenceWrapper) => {
        const caption = evidence.getCaption()
        const isViaRequest = evidence.getIsViaRequest()
        const isAutomated = evidence.getIsAutomated()
        const isLinkedDocument = evidence.getIsLinkedDocument()
        const actorEmail = evidence.getActorEmail()
        const docImportLink = evidence.getDocImportLink()
        const formattedCaption = formatEvidenceCaption(
          caption,
          isAutomated,
          false,
          isViaRequest,
          false,
        )
        const formattedCaptionText =
          typeof formattedCaption === 'string' ? formattedCaption : ''
        const sourceText = getEvidenceSourceLabel(
          isAutomated,
          isLinkedDocument,
          actorEmail,
          docImportLink,
          evidence.getMime(),
        )
        const relevantDate = evidence.getRelevantDate()
        const modifiedDate = evidence.getDocModifiedAt()
        const lastCheckedDate = evidence.getDocScannedAt()
        const relevantDateText = relevantDate
          ? formatISODateTime(relevantDate)
          : ''
        const modifiedDateText = modifiedDate
          ? formatISODateTime(modifiedDate)
          : ''
        const lastCheckedDateText = lastCheckedDate
          ? formatISODateTime(lastCheckedDate)
          : ''
        return [
          formattedCaptionText,
          sourceText,
          actorEmail,
          relevantDateText,
          modifiedDateText,
          lastCheckedDateText,
          // Shown in place of the modified and checked dates without SharePoint.
          evidence.getCreatedAt()
            ? formatISODateTime(evidence.getCreatedAt())
            : '',
          // The By column's avatar names the actor in its tooltip.
          evidence.getActorName(),
          labelNamesForSearch(evidence.getLabelIdsList(), labelMap),
        ]
      },
      (evidence: EvidenceWrapper) => {
        return [evidence.getContentId() || '']
      },
    )
  }, [evidence, labelMap])

  return searchableEvidence
}

export const useSearchableEvidenceInstance = (
  evidenceRows: GridValidRowModel[],
): SearchableData<GridValidRowModel>[] => {
  const searchableEvidence = useMemo(() => {
    return prepareSearchableData(
      evidenceRows,
      (evidenceRow: GridValidRowModel) => Object.values(evidenceRow)[0],
      // Each cell as the grid shows it, so a details cell matches its preview text.
      (evidenceRow: GridValidRowModel) =>
        Object.values(evidenceRow).map((value) => cellDisplayText(value)),
    )
  }, [evidenceRows])

  return searchableEvidence
}

export const useControlToEvidenceMappings = (
  controlIds?: string[],
): GrpcResponse<GetControlToEvidenceMappingsResponse> => {
  const request = new GetControlToEvidenceMappingsRequest()
  if (controlIds && controlIds?.length > 0) {
    request.setControlFilter(new ControlFilter().setControlIdsList(controlIds))
  }
  const { response } = useSwrImmutableGrpc(
    EvidenceManagementPromiseClient.prototype.getControlToEvidenceMappings,
    request,
    true,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceToControlMappings = (
  evidenceIds?: string[],
): GrpcResponse<GetEvidenceToControlMappingsResponse> => {
  const request = new GetEvidenceToControlMappingsRequest()
  if (evidenceIds && evidenceIds?.length > 0) {
    request.setEvidenceFilter(
      new EvidenceManagementEvidenceFilter().setEvidenceIdsList(evidenceIds),
    )
  }
  const { response } = useSwrImmutableGrpc(
    EvidenceManagementPromiseClient.prototype.getEvidenceToControlMappings,
    request,
    true,
  )
  return NewGrpcResponse(response)
}

export const useCreateReceptor = (): ((params: {
  name: string
  modelId: string
  tenantId: string
  description?: string
  config?: string
}) => Promise<ReceptorRecord>) => {
  const client = useAuthorizedGrpcClient(ReceptorPromiseClient)
  const mutate = useInvalidateReceptorsCache()

  return useCallback(
    async ({ name, modelId, tenantId, description, config = '{}' }) => {
      const normalizedTenantId = (tenantId || '').trim()
      const fallbackTenantId = (name || '').trim() || `${modelId}-tenant`

      const request = new ReceptorRecord()
        .setName(name)
        .setModelid(modelId)
        .setTenantid(normalizedTenantId || fallbackTenantId)
        .setDescription(description || '')
        .setConfig(config)
        .setIsenabled(false)
        .setIscredvalid(false)

      const response = await client.createReceptor(request)
      await mutate()
      return response
    },
    [client, mutate],
  )
}

export const useDirectoryScanSetting = (
  scanSettingId: string | undefined,
  shouldFetch = true,
): GrpcResponse<GetDirectoryScanSettingResponse> => {
  const request = useMemo(() => {
    if (!scanSettingId) return null
    return new GetDirectoryScanSettingRequest().setScanSettingId(scanSettingId)
  }, [scanSettingId])

  const { response } = useSwrImmutableGrpc(
    ReceptorUtilPromiseClient.prototype.getDirectoryScanSetting,
    request as GetDirectoryScanSettingRequest,
    !!request && shouldFetch,
  )

  return NewGrpcResponse(response)
}

export const useDirectoryScanSettingEvidences = (
  scanSettingIds: string[] | undefined,
  shouldFetch = true,
): {
  evidences: Evidence[]
  isLoading: boolean
  error: Error | null
} => {
  const client = useAuthorizedGrpcClient(ReceptorUtilPromiseClient)
  const normalizedScanSettingIds = useMemo(
    () =>
      Array.from(
        new Set(
          (scanSettingIds || [])
            .map((id) => id.trim())
            .filter((id) => id.length > 0),
        ),
      ).sort(),
    [scanSettingIds],
  )
  const normalizedScanSettingIdsKey = useMemo(
    () => normalizedScanSettingIds.join(','),
    [normalizedScanSettingIds],
  )
  const [evidences, setEvidences] = useState<Evidence[]>([])
  const [isLoading, setIsLoading] = useState(
    shouldFetch && normalizedScanSettingIds.length > 0,
  )
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let cancelled = false

    const idsToFetch =
      normalizedScanSettingIdsKey === ''
        ? []
        : normalizedScanSettingIdsKey.split(',')

    if (!shouldFetch || idsToFetch.length === 0) {
      setEvidences([])
      setIsLoading(false)
      setError(null)
      return () => {
        cancelled = true
      }
    }

    setIsLoading(true)
    setError(null)

    void Promise.all(
      idsToFetch.map((scanSettingId) =>
        client.getDirectoryScanSetting(
          new GetDirectoryScanSettingRequest().setScanSettingId(scanSettingId),
        ),
      ),
    )
      .then((responses) => {
        if (cancelled) {
          return
        }

        const dedupedEvidences: Evidence[] = []
        const seenEvidenceIds = new Set<string>()

        responses.forEach((response) => {
          response.getEvidencesList().forEach((evidence) => {
            const evidenceId = evidence.getId()
            if (!evidenceId || seenEvidenceIds.has(evidenceId)) {
              return
            }
            seenEvidenceIds.add(evidenceId)
            dedupedEvidences.push(evidence)
          })
        })

        setEvidences(dedupedEvidences)
      })
      .catch((err: Error) => {
        if (cancelled) {
          return
        }
        setEvidences([])
        setError(err)
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [client, normalizedScanSettingIdsKey, shouldFetch])

  return { evidences, isLoading, error }
}

export function useListDirectoryScanSettings(
  receptorId?: string,
  policyModelId?: string,
  shouldFetch = true,
  pageSize?: number,
  pageNumber?: number,
): GrpcResponse<ListDirectoryScanSettingsResponse> {
  // The settings' evidence_count follows the window, so it agrees with the evidence lists
  // beside it — a scan collects a document with the document's own date, so it can find
  // evidence a control test then ignores.
  const { auditId } = useInAudit()
  const location = useLocation()
  const showAllDates = useMemo(
    () => isShowingAllDates(parseSourceQueryParams(location.search)),
    [location.search],
  )
  const request = useMemo(() => {
    const req = new ListDirectoryScanSettingsRequest()
    req.setAuditId(auditId || '')
    req.setIncludeOutOfWindow(showAllDates)
    if (receptorId) {
      req.setReceptorIdList([receptorId])
    }
    if (policyModelId) {
      req.setModelId(policyModelId)
    }
    if (pageSize) {
      req.setPageSize(pageSize)
    }
    if (pageNumber) {
      req.setPageNumber(pageNumber)
    }
    return req
  }, [receptorId, policyModelId, pageSize, pageNumber, auditId, showAllDates])
  const { response } = useSwrImmutableGrpc(
    ReceptorUtilPromiseClient.prototype.listDirectoryScanSettings,
    request,
    shouldFetch,
  )

  return NewGrpcResponse(response)
}

export const useInvalidateDirectoryScanSettings = (): (() => Promise<void>) => {
  const mutateFunc = useGrpcRevalidateByMethod()

  return useCallback(async () => {
    await Promise.all([
      mutateFunc(ReceptorUtilPromiseClient.prototype.listDirectoryScanSettings),
      mutateFunc(ReceptorUtilPromiseClient.prototype.getDirectoryScanSetting),
    ])
  }, [mutateFunc])
}

export const useDeleteDirectoryScanSetting = (): ((
  scanSettingId: string,
  receptorId: string,
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(ReceptorUtilPromiseClient)
  const invalidate = useInvalidateDirectoryScanSettings()

  return useCallback(
    async (scanSettingId: string, receptorId: string) => {
      const request = new DeleteDirectoryScanSettingRequest()
      request.setScanSettingId(scanSettingId)
      request.setReceptorIdList([receptorId])

      await client.deleteDirectoryScanSetting(request)
      await invalidate()
    },
    [client, invalidate],
  )
}

export const useUpdateDirectoryScanSetting = (): ((
  req: UpdateDirectoryScanSettingRequest,
) => Promise<UpdateDirectoryScanSettingResponse>) => {
  const client = useAuthorizedGrpcClient(ReceptorUtilPromiseClient)
  const invalidate = useInvalidateDirectoryScanSettings()

  return useCallback(
    async (req: UpdateDirectoryScanSettingRequest) => {
      const response = await client.updateDirectoryScanSetting(req)
      await invalidate()
      return response
    },
    [client, invalidate],
  )
}

export const useUpdateDirectoryScanSettingLabels = (): (({
  scanSettingId,
  labelIds,
}: {
  scanSettingId: string
  labelIds: string[]
}) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(ReceptorUtilPromiseClient)
  const invalidate = useInvalidateDirectoryScanSettings()

  return useCallback(
    async ({
      scanSettingId,
      labelIds,
    }: {
      scanSettingId: string
      labelIds: string[]
    }) => {
      const request = new UpdateDirectoryScanSettingLabelsRequest()
        .setScanSettingId(scanSettingId)
        .setLabelIdsList(labelIds)
      await client.updateDirectoryScanSettingLabels(request)
      await invalidate()
    },
    [client, invalidate],
  )
}

// Every call recomputes the account's suggestions, so a failure waits for Refresh.
export const SUGGESTIONS_SWR_CONFIG = { shouldRetryOnError: false }

export const useControlToEvidenceMappingInfo = ({
  controlIds,
  defaultToAll,
  enabled = true,
}: {
  controlIds?: string[]
  defaultToAll?: boolean
  enabled?: boolean
}): GrpcResponse<GetControlToEvidenceMappingInfoResponse> => {
  const hasControlEvidenceMappings = IsGatekeeperEnabled(
    GatekeeperFlag.CONTROL_EVIDENCE_MAPPINGS,
  )
  // Scoped like every other evidence list: the window decides what a control test would
  // count, and Show All lifts it. Suggesting evidence the test ignores is worse than listing
  // it, because acting on the suggestion looks like progress it will not credit.
  const { auditId } = useInAudit()
  const location = useLocation()
  const showAllDates = useMemo(
    () => isShowingAllDates(parseSourceQueryParams(location.search)),
    [location.search],
  )
  const request = new GetControlToEvidenceMappingInfoRequest()
    .setAuditId(auditId || '')
    .setIncludeOutOfWindow(showAllDates)
  if (controlIds && controlIds?.length > 0) {
    request.setControlFilter(new ControlFilter().setControlIdsList(controlIds))
  }
  if (defaultToAll) {
    request.setDefaultToAll(true)
  }
  const { response } = useSwrImmutableGrpc(
    EvidenceManagementPromiseClient.prototype.getControlToEvidenceMappingInfo,
    request,
    hasControlEvidenceMappings && enabled,
    SUGGESTIONS_SWR_CONFIG,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceToControlMappingInfo = ({
  evidenceIds,
  defaultToAll,
  enabled = true,
}: {
  evidenceIds?: string[]
  defaultToAll?: boolean
  enabled?: boolean
}): GrpcResponse<GetEvidenceToControlMappingInfoResponse> => {
  const hasControlEvidenceMappings = IsGatekeeperEnabled(
    GatekeeperFlag.CONTROL_EVIDENCE_MAPPINGS,
  )
  // Scoped like every other evidence list: the window decides what a control test would
  // count, and Show All lifts it. Suggesting evidence the test ignores is worse than listing
  // it, because acting on the suggestion looks like progress it will not credit.
  const { auditId } = useInAudit()
  const location = useLocation()
  const showAllDates = useMemo(
    () => isShowingAllDates(parseSourceQueryParams(location.search)),
    [location.search],
  )
  const request = new GetEvidenceToControlMappingInfoRequest()
    .setAuditId(auditId || '')
    .setIncludeOutOfWindow(showAllDates)
  if (evidenceIds && evidenceIds?.length > 0) {
    request.setEvidenceFilter(
      new EvidenceManagementEvidenceFilter().setEvidenceIdsList(evidenceIds),
    )
  }
  if (defaultToAll) {
    request.setDefaultToAll(true)
  }
  const { response } = useSwrImmutableGrpc(
    EvidenceManagementPromiseClient.prototype.getEvidenceToControlMappingInfo,
    request,
    hasControlEvidenceMappings && enabled,
    SUGGESTIONS_SWR_CONFIG,
  )
  return NewGrpcResponse(response)
}

export const useEvidenceControlMappings = ({
  evidenceIds,
  defaultToAll,
  enabled,
}: {
  evidenceIds?: string[]
  defaultToAll?: boolean
  enabled?: boolean
}): {
  mappings: EvidenceToControlMappingInfo[]
  isLoading: boolean
  isRefreshing: boolean
  hasError: boolean
  refresh: () => void
  outOfWindowCount: number
} => {
  const { data, error, isLoading, isValidating, mutate } =
    useEvidenceToControlMappingInfo({
      evidenceIds,
      defaultToAll,
      enabled,
    })

  const mappings = useMemo(() => {
    return data?.getEvidenceControlMappingsList() || []
  }, [data])
  const refresh = useCallback(() => {
    void mutate()
  }, [mutate])

  return {
    mappings,
    isLoading,
    isRefreshing: isValidating,
    hasError: !!error,
    refresh,
    outOfWindowCount: data?.getOutOfWindowCount() || 0,
  }
}

export const useControlEvidenceMappings = ({
  controlIds,
  defaultToAll = false,
  enabled,
}: {
  controlIds?: string[]
  defaultToAll?: boolean
  enabled?: boolean
}): {
  mappings: ControlToEvidenceMappingInfo[]
  isLoading: boolean
  isRefreshing: boolean
  hasError: boolean
  refresh: () => void
  // Suggestions and gaps only. Linked evidence is counted separately because the control
  // show page's tab renders the first two and not the third.
  outOfWindowCount: number
  linkedOutOfWindowCount: number
  // The two above de-duplicated. A surface rendering all three lists uses this: evidence
  // linked to one control and suggested for another sits in both counts, so adding them
  // reports one hidden evidence as two.
  combinedOutOfWindowCount: number
} => {
  const { data, error, isLoading, isValidating, mutate } =
    useControlToEvidenceMappingInfo({
      controlIds,
      defaultToAll,
      enabled,
    })

  const mappings = useMemo(() => {
    return data?.getControlEvidenceMappingsList() || []
  }, [data])
  const refresh = useCallback(() => {
    void mutate()
  }, [mutate])

  return {
    mappings,
    isLoading,
    isRefreshing: isValidating,
    hasError: !!error,
    refresh,
    outOfWindowCount: data?.getOutOfWindowCount() || 0,
    linkedOutOfWindowCount: data?.getLinkedOutOfWindowCount() || 0,
    combinedOutOfWindowCount: data?.getCombinedOutOfWindowCount() || 0,
  }
}

const INDEXING_POLL_INTERVAL_MS = 5000
const INDEXING_WAIT_LIMIT_MS = 3 * 60 * 1000

// Polls the RPC directly: SWR could hand back an earlier upload's result for a re-uploaded id.
export const useWaitForEvidenceIndexing = (
  evidenceIds: string[],
): { isIndexed: boolean; isTimedOut: boolean; restart: () => void } => {
  const client = useAuthorizedGrpcClient(EvidenceServicePromiseClient)
  const [isIndexed, setIsIndexed] = useState(false)
  const [isTimedOut, setIsTimedOut] = useState(false)
  const idsKey = evidenceIds.join(',')
  const isWaiting = idsKey !== '' && !isIndexed && !isTimedOut

  useEffect(() => {
    if (!isWaiting) return
    let cancelled = false
    let timeoutId: ReturnType<typeof setTimeout>
    const request = new ListEvidenceBeingIndexedRequest().setEvidenceFilter(
      new EvidenceServiceEvidenceFilter().setEvidenceIdsList(idsKey.split(',')),
    )

    const poll = async () => {
      try {
        const response = await client.listEvidenceBeingIndexed(request)
        if (cancelled) return
        if (response.getEvidenceIdsList().length === 0) {
          setIsIndexed(true)
          return
        }
      } catch (err) {
        log.error('Error checking evidence indexing status', err)
      }
      if (!cancelled) {
        timeoutId = setTimeout(poll, INDEXING_POLL_INTERVAL_MS)
      }
    }

    poll()

    return () => {
      cancelled = true
      clearTimeout(timeoutId)
    }
  }, [client, idsKey, isWaiting])

  useEffect(() => {
    if (!isWaiting) return
    const timeoutId = setTimeout(
      () => setIsTimedOut(true),
      INDEXING_WAIT_LIMIT_MS,
    )
    return () => clearTimeout(timeoutId)
  }, [isWaiting])

  const restart = useCallback(() => setIsTimedOut(false), [])

  return { isIndexed, isTimedOut, restart }
}

export const useConfirmLinkEvidenceToControl = ({
  evidenceIds,
  controlId,
  captions,
  controlName,
  mutateFunc,
  title,
}: {
  evidenceIds: string[]
  controlId: string
  captions: string[]
  controlName?: string
  mutateFunc?: () => Promise<void>
  title?: string
}): (() => void) => {
  const { setConfirmationState } = useContext(ConfirmationContext)
  const attachmentClient = useAuthorizedGrpcClient(AttachmentPromiseClient)

  const linkEvidenceToControl = async () => {
    try {
      const linkEvidenceToControlReq = new LinkEvidenceToControlRequest()
        .setEvidenceIdsList(evidenceIds)
        .setControlId(controlId)
      await attachmentClient.linkEvidenceToControl(linkEvidenceToControlReq)
    } catch (err: unknown) {
      const resError = err as RpcError
      const errorMessage = getErrorMessage(resError)
      if (errorMessage.shouldLog) {
        log.error('Error in Link Evidence modal:', errorMessage.message)
      }
      setConfirmationState({
        isShown: true,
        size: 'lg',
        title: 'Error Linking Evidence',
        body: <p>{errorMessage.message}</p>,
        confirmText: 'OK',
        hideCancel: true,
        onConfirmCB: () => null,
      })
    } finally {
      isFunction(mutateFunc) && (await mutateFunc())
    }
  }
  const confirmationModalProps = {
    title: title || `Link evidence to control?`,
    body: (
      <>
        <p>{`The following evidence will be linked to '${controlName}':`}</p>
        <ul>
          {captions.map((caption, index) => (
            <li key={`${caption}-${index}`}>{caption}</li>
          ))}
        </ul>
      </>
    ),
    confirmText: 'Link Evidence',
    onConfirmCB: linkEvidenceToControl,
  }

  return useConfirmationModal(confirmationModalProps)
}

export const useConfirmLinkControlsToEvidence = ({
  evidenceId,
  controlIds,
  controlNames,
  caption,
  mutateFunc,
  title,
}: {
  evidenceId: string
  controlIds: string[]
  controlNames: string[]
  caption?: string
  mutateFunc?: () => Promise<void>
  title?: string
}): (() => void) => {
  const { setConfirmationState } = useContext(ConfirmationContext)
  const attachmentClient = useAuthorizedGrpcClient(AttachmentPromiseClient)

  const linkControlsToEvidence = async () => {
    try {
      const linkControlsToEvidenceReq = new LinkControlsToEvidenceRequest()
        .setEvidenceId(evidenceId)
        .setControlIdsList(controlIds)
      await attachmentClient.linkControlsToEvidence(linkControlsToEvidenceReq)
    } catch (err: unknown) {
      const resError = err as RpcError
      const errorMessage = getErrorMessage(resError)
      if (errorMessage.shouldLog) {
        log.error('Error in Link Evidence modal:', errorMessage.message)
      }
      setConfirmationState({
        isShown: true,
        size: 'lg',
        title: 'Error Linking Controls to Evidence',
        body: <p>{errorMessage.message}</p>,
        confirmText: 'OK',
        hideCancel: true,
        onConfirmCB: () => null,
      })
    } finally {
      isFunction(mutateFunc) && (await mutateFunc())
    }
  }
  const confirmationModalProps = {
    title: title || `Link controls to evidence?`,
    body: (
      <>
        <p>{`The following controls will be linked to '${caption}':`}</p>
        <ul>
          {controlNames.map((controlName, index) => (
            <li key={`${controlName}-${index}`}>{controlName}</li>
          ))}
        </ul>
      </>
    ),
    confirmText: 'Link Controls',
    onConfirmCB: linkControlsToEvidence,
  }

  return useConfirmationModal(confirmationModalProps)
}

const EVIDENCE_SCAN_POLL_INTERVAL_MS = 5000

export function useEvidenceFolderScanRefresh(): {
  evidenceFolderScanInProgress: boolean
} {
  const { data: directoryScanSettings } = useListDirectoryScanSettings()
  // Scanned evidence has no suggestions until it's indexed, so scans skip the mapping RPCs.
  const invalidateEvidence = useInvalidateEvidence({ includeMappings: false })
  const invalidateDirectoryScan = useInvalidateDirectoryScanSettings()

  const evidenceFolderScanSettingIds = useMemo(() => {
    const ids = new Set<string>()
    directoryScanSettings?.getSettingsList().forEach((s) => {
      if (s.getDocumentType() === DOCUMENT_TYPE.EVIDENCE) {
        const id = s.getId()?.trim()
        if (id) ids.add(id)
      }
    })
    return ids
  }, [directoryScanSettings])

  const { data: inProgressScans } = useInProgressReceptorScans(true, {
    refreshInterval:
      evidenceFolderScanSettingIds.size > 0
        ? EVIDENCE_SCAN_POLL_INTERVAL_MS
        : 0,
  })

  const evidenceFolderScanInProgress = useMemo(() => {
    if (evidenceFolderScanSettingIds.size === 0) return false
    const scans = inProgressScans?.getScansList() || []
    return scans.some((scan) => {
      const keys = scan.getImportKeysList()
      if (!keys.length) return false
      return keys.some((key) => evidenceFolderScanSettingIds.has(key))
    })
  }, [inProgressScans, evidenceFolderScanSettingIds])

  // Refresh evidence caches while scan is in progress
  useEffect(() => {
    if (!evidenceFolderScanInProgress) return
    const intervalId = window.setInterval(() => {
      void invalidateEvidence()
    }, EVIDENCE_SCAN_POLL_INTERVAL_MS)
    return () => clearInterval(intervalId)
  }, [evidenceFolderScanInProgress, invalidateEvidence])

  // Invalidate caches when scan completes
  const prevInProgressRef = useRef(false)
  useEffect(() => {
    if (prevInProgressRef.current && !evidenceFolderScanInProgress) {
      void Promise.all([invalidateEvidence(), invalidateDirectoryScan()])
    }
    prevInProgressRef.current = evidenceFolderScanInProgress
  }, [
    evidenceFolderScanInProgress,
    invalidateEvidence,
    invalidateDirectoryScan,
  ])

  return { evidenceFolderScanInProgress }
}

// Links one label to evidence, or unlinks it, leaving its other labels as they are.
export const useSetEvidenceLabel = (): (({
  evidenceId,
  labelId,
  linked,
}: {
  evidenceId: string
  labelId: string
  linked: boolean
}) => Promise<EvidenceGroup>) => {
  const mutator = useInvalidateEvidence()
  const attachmentClient = useAuthorizedGrpcClient(AttachmentPromiseClient)

  return useCallback(
    async ({ evidenceId, labelId, linked }) => {
      const response = linked
        ? await attachmentClient.addEvidenceLabel(
            new AddEvidenceLabelRequest()
              .setEvidenceId(evidenceId)
              .setLabelId(labelId),
          )
        : await attachmentClient.removeEvidenceLabel(
            new RemoveEvidenceLabelRequest()
              .setEvidenceId(evidenceId)
              .setLabelId(labelId),
          )
      await mutator()
      return response
    },
    [attachmentClient, mutator],
  )
}
